/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React from 'react';
import moment from 'moment';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  Pagination,
  Menu,
  MenuItem,
  TableContainer,
  Tooltip,
  Chip,
  CircularProgress,
  // Popover,
} from '@mui/material';
import {
  useTheme,
  withStyles,
} from '@mui/styles';
import {
  Check,
  CheckCircle,
  Event,
  Today,
} from '@mui/icons-material';
import {
  changeStatus,
  patchEvent,
} from '@pingum/app-state-management/event/actions';

import { groupBy } from 'lodash';
import SelectIcon from '../../../../images/unused-undraw-illustrations/undraw_select_option_re_u4qn.svg';
import styles from './styles';
import LoadingTaskRow from './components/LoadingTaskRow';
import ErrorIcon from '../../../../images/unused-undraw-illustrations/undraw_server_down_s-4-lk.svg';

import buildOverviewGrid, {
  getDaysBetweenDatesObject,
  buildOverviewDayTaskData,
} from './buildOverviewGrid';

import Toolbar from './components/Toolbar';
// setSelectedBarnHorse,
import { setGlobalModals } from '../../../../redux/app/actions';
import { getBarnBoardSuggestions } from '../../../../redux/board/actions';
import { generateBarnBoardSuggestions } from '../../../../utils/barnBoardHelper';
import {
  SCHEDULE_MODAL_TYPE,
  SET_GLOABL_MODALS,
  TASK_MODAL_TYPE,
} from '../../../../redux/app/types';
import TagReminderModal from '../../../../pages/settings/TaskPage/reminders/components/TagReminder/components/TagReminderModal';
import HorsesCardComponent from '../../../../pages/settings/LocationSettingsPage/locations/components/HorsesCard';
import { TaskCalenderOverviewLocationCell } from './components/TaskCalenderOverviewLocationRow';
import { TaskCalendarOverviewHorseRow } from './components/TaskCalenderOverviewHorseRow';
import { SET_BOARD_PLANNING_DAY } from '../../../../redux/board/types';
// import Horse from '../../../Horse';

const customComparator = (prevProps, nextProps) => prevProps.startDate === nextProps.startDate
  && prevProps.endDate === nextProps.endDate

const TasksComponent = React.memo(({
  classes,
  navigate,
  handleRefresh,
  // eslint-disable-next-line no-unused-vars
  handleOpenScheduleModal,
  selectedScheduleUser,
  setOpenQuickSelectMenu,
  setSelectedSlot,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  setSlotBarnHorses,
  loadData,
}) => {
  const todayTimestamp = moment().startOf('day').toDate().getTime();
  const endPlanningTimestamp = moment().startOf('day').add(15, 'hour').toDate()
    .getTime();
  const theme = useTheme();
  const dispatch = useDispatch();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // State
  const [overview, setOverview] = React.useState([]);
  const [dayTaskData, setDayTaskData] = React.useState({});
  const [selectedBarnHorses, setSelectedBarnHorses] = React.useState([]);
  const [selectedDay, setSelectedDay] = React.useState(null);
  const [planningMode, setPlanningMode] = React.useState(null);
  const [itemSelectAnchorEl, setItemSelectAnchorEl] = React.useState(null);
  const [openItemSelectMenu, setOpenItemSelectMenu] = React.useState(null);
  const [eventOptions, setEventOptions] = React.useState(null);
  const [doNotScroll, setDoNotScroll] = React.useState(false);
  const [sliceIndex, setSliceIndex] = React.useState(0);
  const [boardSuggestions, setBoardSuggestions] = React.useState({});
  const [selectedTagReminder, setSelectedTagReminder] = React.useState(null)
  const [horseLocationsByTag, setHorseLocationsByTag] = React.useState({});
  const [confirmCompleteTasks, setConfirmCompleteTasks] = React.useState(false);

  React.useEffect(() => {
    if (fullScreen) {
      // set to single day
      setSelectedDay(`${moment(new Date()).startOf('day').toDate().getTime()}`)
    }
  }, [fullScreen]);

  React.useEffect(() => {
    dispatch({
      type: SET_GLOABL_MODALS,
      inlineDrawer: !!planningMode,
    })
    dispatch({
      type: SET_BOARD_PLANNING_DAY,
      planningDay: (!!planningMode && selectedDay),
    })
  }, [planningMode, selectedDay]);

  // Redux
  const selectedLocation = useSelector((state) => state.location.selectedLocation);
  const eventData = useSelector((state) => state.eventData.eventData);
  const statuses = useSelector((state) => state.status.statuses);
  const isFetchingEventTemplates = useSelector((state) => state.eventTemplate.isFetchingEventTemplates);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const isFetchingBoard = useSelector((state) => state.board.isFetchingBoard);
  const errorMessage = useSelector((state) => state.board.errorMessage);
  const barnHorses = useSelector((state) => state.board.barnHorses);
  const tasks = useSelector((state) => state.board.tasks);
  const events = useSelector((state) => state.board.events);
  const boardBarnHorses = useSelector((state) => state.board.barnHorses);
  const mappedHorseSuggestions = useSelector((state) => state.board.mappedHorseSuggestions);
  const upcomingDueDates = useSelector((state) => state.board.upcomingDueDates);
  const allHorseLocations = useSelector((state) => state.location.allHorseLocations);
  const isUpdatingEvent = useSelector((state) => state.event.isUpdatingEvent);
  const isChangingStatus = useSelector((state) => state.event.isChangingStatus);

  React.useEffect(() => {
    // Last get any board suggestions
    if (boardBarnHorses && boardBarnHorses.length > 0) {
      dispatch(getBarnBoardSuggestions(boardBarnHorses))
    }
  }, [boardBarnHorses])

  React.useEffect(() => {
    if (overview && boardBarnHorses.length > 0
      && Object.keys(overview).length === boardBarnHorses.length + 1) {
      setBoardSuggestions(generateBarnBoardSuggestions(
        barnHorses,
        overview,
        mappedHorseSuggestions || {},
        upcomingDueDates,
        startDate,
        endDate,
      ))
    }
  }, [overview, upcomingDueDates, mappedHorseSuggestions])

  React.useEffect(() => {
    // Used for the schedule button in the filter component so selected horses in grid are passed to schedule modals
    setSlotBarnHorses(selectedBarnHorses);
  }, [selectedBarnHorses])

  React.useEffect(() => {
    // Last get any board suggestions
    if (boardBarnHorses && boardBarnHorses.length > 0) {
      dispatch(getBarnBoardSuggestions(boardBarnHorses))
    }
  }, [boardBarnHorses])

  React.useEffect(() => {
    const newOverview = buildOverviewGrid(
      selectedLocation,
      barnHorses,
      barnUsersMap,
      events,
      tasks,
      startDate,
      endDate,
      (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTagTypeId) || 0,
      barnHorsesMap,
      selectedBarn.barnMetadata,
      eventData.reduce((map, obj) => {
        const mappedData = map;
        mappedData[obj.id] = obj;
        return mappedData;
      }, {}),
      statuses.filter((s) => s.id !== selectedBarn.barnMetadata.statusStartId
        && s.id !== selectedBarn.barnMetadata.statusPendingId && s.id !== selectedBarn.barnMetadata.statusEndId),
    );
    setOverview(newOverview);

    setDayTaskData(buildOverviewDayTaskData(
      startDate,
      endDate,
      events,
      tasks,
    ))

    if (!doNotScroll && !!document.getElementById('scroll-to-today') && !selectedDay) {
      // We only want to scroll on page load otherwise
      // this will scroll after each update...
      setTimeout(() => {
        document.getElementById('scroll-to-today').scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'center',
        });
        document.documentElement.scrollTop = 0;
      }, 500)
    }
  }, [events, tasks]);

  React.useEffect(() => {
    setHorseLocationsByTag(groupBy((allHorseLocations || [])
      .map((hl) => ({
        ...hl,
        tagId: (barnHorsesMap[hl.horse.id] && barnHorsesMap[hl.horse.id][0].pingumTagId) || 0,
      })), 'tagId'))
  }, [allHorseLocations])

  const handleOverviewItemClick = (e, item, openModal = true) => {
    setEventOptions(null);
    setItemSelectAnchorEl(null);
    setOpenItemSelectMenu(false);
    if (item.task) {
      dispatch(setGlobalModals(openModal
        ? TASK_MODAL_TYPE
        : 'unknown', item.task, (item.event && item.event.resource) || null, item.event || null, {}, null));
    } else {
      dispatch(setGlobalModals(openModal
        ? SCHEDULE_MODAL_TYPE
        : 'unknown', null, item.event.resource, item.event, {
        locationId: item.event.eventTask
          ? selectedLocation.id
          : null, // if set, this is a calendar event
        taskTagIds: [],
        eventTemplateTagTypeFilter: -1,
        openInSeries: false,
        startDate: null,
        assignment: selectedScheduleUser,
        rescheduleDate: null,
        drawer: !!(planningMode || selectedDay),
      }, (reload) => {
        if (reload) {
          handleRefresh();
        }
      }));
    }
  }

  React.useEffect(() => {
    setTimeout(() => {
      // We only want to scroll on page load otherwise
      // this will scroll after each update...
      setDoNotScroll(true)
    }, 4000)
  }, [])

  const handleCalendarEventItemClick = (e, items) => {
    if (items && items.length > 1) {
      setEventOptions(items);
      setItemSelectAnchorEl(e.target);
      setOpenItemSelectMenu(true);
    } else if (items.length === 1) {
      handleOverviewItemClick(e, items[0])
    }
  }

  const handleOverviewItemTaskStateChangeClick = (item, callBackOnDone) => {
    if (!item || !item.task) {
      console.error('Selected task item is not valid. No task found');
      return;
    }
    if (item.task.completeDate) {
      // reactivate
      dispatch(patchEvent(item.task.id, { completeEvent: false })).then(() => {
        dispatch(changeStatus(
          item.task.id,
          {
            statusId: parseInt(selectedBarn.barnMetadata.statusPendingId, 10),
            statusComment: null,
            completeEvent: false,
            assignment: (item.task.currentEventStatus && item.task.currentEventStatus.assignment) || '',
          },
          () => {
            setTimeout(() => {
              callBackOnDone();
            }, 500); // small delay for animation
          },
        ));
      });
    } else {
      // complete
      dispatch(changeStatus(
        item.task.id,
        {
          statusId: parseInt(selectedBarn.barnMetadata.statusEndId, 10),
          statusComment: 'Task marked complete',
          completeEvent: true,
          assignment: (item.task.currentEventStatus && item.task.currentEventStatus.assignment) || '',
        },
        () => {
          setTimeout(() => {
            callBackOnDone();
          }, 500); // small delay for animation
        },
      ));
    }
  }

  const actionCompleteCallback = () => {
    setSelectedBarnHorses([]);
  }

  const handleCompleteTasks = (dayKey) => {
    // get all active and incomplete tasks for day
    const { incompleteTasks } = dayTaskData[dayKey];
    for (let i = 0; i < incompleteTasks.length; i += 1) {
      handleOverviewItemTaskStateChangeClick({ task: incompleteTasks[i] }, () => { });
      // TODO make this better or add new API to bulk complete, for now adding small delay every 5 tasks
      if (i % 5 === 0) {
        setTimeout(() => {

        }, 500)
      }
    }
    setTimeout(() => {
      setConfirmCompleteTasks(false);
    }, 1100)
  }

  const isLoading = (isFetchingBoard || isFetchingEventTemplates);
  return (
    <Box>
      {
        !planningMode && (
          <Toolbar
            fullScreen={fullScreen}
            selectedDay={selectedDay}
            setSelectedDay={(day) => {
              setSelectedDay(day);
            }}
            handleRefresh={handleRefresh}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            boardSuggestions={boardSuggestions}
            navigate={navigate}
          />
        )
      }
      {
        !isLoading && errorMessage && (
          <Box
            sx={{
              margin: 'auto',
              p: 2,
              textAlign: 'center',
            }}
          >
            <Typography variant="h3" align="center" color="error" component="div" sx={{ m: 4 }}>
              Oops... There Was An Error!
            </Typography>
            <Typography align="center" component="div" sx={{ m: 4 }}>
              {errorMessage || 'Error'}
            </Typography>
            <img
              src={ErrorIcon}
              alt="issue with server"
              style={{
                width: 250,
                display: 'block',
                margin: 'auto',
                marginBottom: '1rem',
              }}
            />
          </Box>
        )
      }
      {
        (!isLoading && !errorMessage && !selectedLocation && !selectedLocation.id) && (
          <Box
            sx={{
              margin: 'auto',
              p: 2,
              textAlign: 'center',
            }}
          >
            <Typography variant="captions" align="center" component="div" sx={{ m: 4 }}>
              Select a location to view task overview
            </Typography>
            <img
              src={SelectIcon}
              alt="man selecting something"
              style={{
                width: 250,
                display: 'block',
                margin: 'auto',
                marginBottom: '1rem',
              }}
            />
          </Box>
        )
      }
      {
        (!errorMessage && selectedLocation && selectedLocation.id) && (
          <Grid container spacing={4}>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                gap: 4,
              }}
            >
              <Paper classes={{ root: classes.paperRoot }} sx={{ flex: 1 }}>
                <TableContainer sx={{ maxHeight: window.innerHeight - 200 }}>
                  <Table size="small" className={classes.table} stickyHeader>
                    <TableHead>
                      <TableRow>
                        {!fullScreen && (
                          <TableCell varient="head" className={classes.cellHeadSticky} />
                        )}
                        <TableCell varient="head" className={classes.cellHeadSticky}>
                          <HorsesCardComponent
                            location={selectedLocation}
                            onlyButton
                            variant="text"
                            icon
                            onHorsesAdded={() => {
                              setTimeout(() => {
                                loadData(true)
                              }, 500)
                            }}
                          />
                        </TableCell>
                        {
                          Object.keys(getDaysBetweenDatesObject(moment(startDate), moment(endDate)))
                            .filter((day) => !selectedDay || day === selectedDay).map((key) => (
                              <TableCell
                                id={key.toString() === todayTimestamp.toString()
                                  ? 'scroll-to-today'
                                  : null}
                                className={key.toString() === todayTimestamp.toString()
                                  ? classes.cellHeadHighlight
                                  : classes.cellHead}
                                varient="head"
                                key={`table-head-${key}`}
                                onClick={() => {
                                  if (!selectedDay) {
                                    setSelectedDay(key);
                                  } else {
                                    setStartDate(moment(parseInt(selectedDay, 10)).startOf('week').toDate());
                                    setEndDate(moment(parseInt(selectedDay, 10)).endOf('week').toDate());
                                    setSelectedDay(null);
                                  }
                                }}
                              >
                                <Grid container spacing={1} alignItems="center">
                                  {
                                    key.toString() === todayTimestamp.toString() && (
                                      <Grid item>
                                        <Tooltip title="Today">
                                          <Today />
                                        </Tooltip>
                                      </Grid>
                                    )
                                  }
                                  <Grid item sx={{ margin: 'auto' }}>
                                    <Box>{moment(parseInt(key, 10)).format('ddd MMM Do')}</Box>
                                    {
                                      (!(parseInt(key, 10) > todayTimestamp
                                        || (parseInt(key, 10) === todayTimestamp && new Date().getTime() < endPlanningTimestamp)))
                                      && (!confirmCompleteTasks || confirmCompleteTasks === key) && (
                                        <Box>
                                          {
                                            dayTaskData[key] && dayTaskData[key].incompleteTasks.length > 0 && (
                                              <Tooltip title="Mark all incomplete Tasks as Completed?">
                                                <Chip
                                                  size="small"
                                                  variant="outlined"
                                                  color={confirmCompleteTasks
                                                    ? 'warning'
                                                    : parseInt(key, 10) === todayTimestamp
                                                      ? 'secondary'
                                                      : 'primary'}
                                                  label={confirmCompleteTasks
                                                    ? (`Confirm Complete ${dayTaskData[key].incompleteTasks.length} Task${dayTaskData[key].incompleteTasks.length > 1
                                                      ? 's'
                                                      : ''}?`)
                                                    : `${dayTaskData[key].incompleteTasks.length} Incomplete Task${dayTaskData[key].incompleteTasks.length > 1
                                                      ? 's'
                                                      : ''}`}
                                                  deleteIcon={
                                                    (isUpdatingEvent || isChangingStatus)
                                                      ? <CircularProgress size={18} />
                                                      : (
                                                        confirmCompleteTasks
                                                          ? <CheckCircle color="success" />
                                                          : <Check color="success" />)
                                                  }
                                                  onDelete={(e) => {
                                                    e.stopPropagation();
                                                    if (!confirmCompleteTasks) {
                                                      setConfirmCompleteTasks(key)
                                                    } else {
                                                      handleCompleteTasks(key)
                                                    }
                                                  }}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (!confirmCompleteTasks) {
                                                      setConfirmCompleteTasks(key)
                                                    } else {
                                                      handleCompleteTasks(key)
                                                    }
                                                  }}
                                                />
                                              </Tooltip>
                                            )
                                          }
                                        </Box>
                                      )
                                    }
                                  </Grid>
                                  <Grid item>
                                    {
                                      !fullScreen && (
                                        (parseInt(key, 10) > todayTimestamp
                                          || (parseInt(key, 10) === todayTimestamp && new Date().getTime() < endPlanningTimestamp))
                                        && (
                                          <Tooltip
                                            title={planningMode
                                              ? 'Exit Planning Mode'
                                              : 'Enter Planning Mode for this Day'}
                                          >
                                            <Chip
                                              variant="outlined"
                                              sx={{
                                                color: parseInt(key, 10) === todayTimestamp
                                                  ? 'white'
                                                  : undefined,
                                              }}
                                              label={!planningMode
                                                ? 'Plan Day'
                                                : 'Stop Planning'}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedDay(planningMode
                                                  ? null
                                                  : key)
                                                setPlanningMode(!planningMode);
                                              }}
                                            />
                                          </Tooltip>
                                        )
                                      )
                                    }
                                  </Grid>
                                </Grid>
                              </TableCell>
                            ))
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        isLoading && [1, 2, 3, 4, 5].map((item) => (
                          <LoadingTaskRow key={`loading-item-${item}`} classes={classes} />
                        ))
                      }
                      {
                        !isLoading && overview[selectedLocation.pingumTagId] && (
                          <TaskCalenderOverviewLocationCell
                            barnHorses={barnHorses}
                            barnHorsesMap={barnHorsesMap}
                            classes={classes}
                            fullScreen={fullScreen}
                            handleCalendarEventItemClick={handleCalendarEventItemClick}
                            handleOverviewItemClick={handleOverviewItemClick}
                            handleOverviewItemTaskStateChangeClick={handleOverviewItemTaskStateChangeClick}
                            overview={overview}
                            selectedBarnHorses={selectedBarnHorses}
                            selectedDay={selectedDay}
                            selectedLocation={selectedLocation}
                            setOpenQuickSelectMenu={setOpenQuickSelectMenu}
                            setSelectedBarnHorses={setSelectedBarnHorses}
                            setSelectedSlot={(slot) => setSelectedSlot({
                              ...slot,
                              drawer: !!planningMode,
                            })}
                            todayTimestamp={todayTimestamp}
                          />

                        )
                      }

                      {
                        !isLoading && (Object.keys(overview)
                          .filter((key) => key !== selectedLocation.pingumTagId)
                          .sort((keyA, keyB) => -(barnHorsesMap[keyB]
                            ? barnHorsesMap[keyB][0].horse.name
                            : 'zz').localeCompare((barnHorsesMap[keyA]
                              ? barnHorsesMap[keyA][0].horse.name
                              : 'zz'))).slice(sliceIndex * 100, (sliceIndex + 1) * 100)
                          .map((key) => {
                            const barnHorse = barnHorsesMap[key]
                              ? barnHorsesMap[key][0]
                              : {
                                id: -1,
                                horse: {
                                  name: 'Unknown',
                                  picture: null,
                                },
                              };
                            return (
                              <TaskCalendarOverviewHorseRow
                                key={`overview-row-${barnHorse.id}`}
                                actionCompleteCallback={actionCompleteCallback}
                                barnHorse={barnHorse}
                                boardSuggestionsKey={boardSuggestions[key]}
                                classes={classes}
                                dispatch={dispatch}
                                fullScreen={fullScreen}
                                handleCalendarEventItemClick={handleCalendarEventItemClick}
                                handleOverviewItemClick={handleOverviewItemClick}
                                handleOverviewItemTaskStateChangeClick={handleOverviewItemTaskStateChangeClick}
                                navigate={navigate}
                                overviewKey={overview[key]}
                                selectedBarnHorses={selectedBarnHorses}
                                selectedDay={selectedDay}
                                setOpenQuickSelectMenu={setOpenQuickSelectMenu}
                                setSelectedBarnHorses={setSelectedBarnHorses}
                                setSelectedSlot={(slot) => setSelectedSlot({
                                  ...slot,
                                  restOfSuggestions: Object.keys(boardSuggestions)
                                    .filter((horseId) => horseId !== 'hasSuggestions' && !slot.barnHorses.find((s) => s.pingumTagId === horseId))
                                    .map((k) => ({
                                      barnHorse: boardSuggestions[k].barnHorse,
                                      allSuggestions: (boardSuggestions[k][slot.dayOfWeek] && boardSuggestions[k][slot.dayOfWeek].allSuggestions)
                                        || [],
                                    })),
                                  drawer: !!planningMode,
                                })}
                                theme={theme}
                                todayTimestamp={todayTimestamp}
                                locationIndicator={horseLocationsByTag[barnHorse.pingumTagId]
                                  && horseLocationsByTag[barnHorse.pingumTagId].length > 1}
                                planningMode={planningMode}
                                handleOpenScheduleModal={(et, isCalendarEvent, slot) => {
                                  handleOpenScheduleModal(et, isCalendarEvent, {
                                    ...slot,
                                    restOfSuggestions: Object.keys(boardSuggestions)
                                      .filter((horseId) => horseId !== 'hasSuggestions' && !slot.barnHorses.find((s) => s.pingumTagId === horseId))
                                      .map((k) => ({
                                        barnHorse: boardSuggestions[k].barnHorse,
                                        allSuggestions: (boardSuggestions[k][slot.dayOfWeek] && boardSuggestions[k][slot.dayOfWeek].allSuggestions)
                                          || [],
                                      })),
                                    drawer: !!planningMode,
                                  })
                                }}
                              />

                            )
                          }))
                      }
                    </TableBody>
                  </Table>
                  {Object.keys(overview).filter((key) => key !== selectedLocation.pingumTagId).length > 100 && (
                    <Box sx={{ m: 2 }}>
                      <Pagination
                        count={parseInt(Math.ceil(Object.keys(overview)
                          .filter((key) => key !== selectedLocation.pingumTagId).length / 100), 10)}
                        variant="outlined"
                        page={sliceIndex + 1}
                        onChange={(event, value) => { setSliceIndex(value - 1); }}
                      />
                      <Typography variant="subtitle1" align="center" component="div" sx={{ mt: 4 }}>
                        This location has a lot of horses. Consider placing your horses into smaller groups by barn &ldquo;location&rdquo; or
                        other criteria (trainers, teams, etc) to make it easier to plan with a smaller and similar subset of horses.
                      </Typography>
                    </Box>
                  )}
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>
        )
      }
      <Menu
        id="item-select-menu"
        anchorEl={itemSelectAnchorEl}
        open={!!openItemSelectMenu}
        onClose={() => { setOpenItemSelectMenu(false); setItemSelectAnchorEl(null); setEventOptions(null); }}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
        PaperProps={{
          style: {
            maxHeight: 100 * 4.5,
            width: '4000',
          },
        }}
      >
        {
          (eventOptions && eventOptions.length > 1) && (
            eventOptions.sort((a, b) => a.sortDateTimestamp - b.sortDateTimestamp).map((item) => (
              <MenuItem key={`item-option-select-${item.id}`} onClick={(e) => { handleOverviewItemClick(e, item); }}>
                <Event color="secondary" fontSize="small" sx={{ mr: 1 }} />{moment(item.event.start).format('h:mm a')}  {item.name}
              </MenuItem>
            ))
          )
        }
      </Menu>
      {
        !!selectedTagReminder && (
          <TagReminderModal
            tagReminder={selectedTagReminder}
            open={!!selectedTagReminder}
            onClose={() => { setSelectedTagReminder(null); dispatch(getBarnBoardSuggestions(boardBarnHorses)) }}
          />
        )
      }
    </Box>
  );
}, customComparator);

TasksComponent.propTypes = {
  classes: PropTypes.object,
  navigate: PropTypes.func.isRequired,
  handleOpenScheduleModal: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  selectedScheduleUser: PropTypes.object,
  setOpenQuickSelectMenu: PropTypes.func.isRequired,
  setSelectedSlot: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  startDate: PropTypes.any.isRequired,
  endDate: PropTypes.any.isRequired,
  setSlotBarnHorses: PropTypes.func.isRequired,
  loadData: PropTypes.func.isRequired,
};
TasksComponent.defaultProps = {
  classes: {},
  selectedScheduleUser: null,
};

export default withStyles(styles)(TasksComponent);

